const resources = {
  fi: {
    translation: {
      // site-wide, headers
      "intro": "Tervetuloa lintuasemasovellus Haukkaan. Suomessa sijaitsee 16 lintuasemaa. Lintuasemasovelluksen avulla käyttäjä voi kirjata lintuasemilla tehtyjä lintujen havaintotietoja vakioidussa muodossa. Havaintojen tallentaminen järjestelmään vaatii sisäänkirjautumisen.",
      "login": "Kirjaudu sisään",
      "logout": "Kirjaudu ulos",
      "User": "Käyttäjä",
      "frontpage": "Etusivu",
      "addDayPage": "Lisää päivä",
      "showDaysPage": "Näytä päivät",
      "observatory": "Lintuasema",
      "summary": "Lajit",
      "obsPeriods": "Jaksot",
      "manualTitle": "Käyttöohjeet",
      "manualTextShort": "Tähän kirjoitetaan lyhyt versio sovelluksen käyttöohjeista.",
      "manualText": "Tähän kirjoitetaan sovelluksen käyttöohjeet kokonaisuudessaan.",
      "speciesTotal": "Lajit lkm",
      "changeObservatory": "Vaihda lintuasemaa",
      "chooseObservatory": "Valitse lintuasema",
      "currentObservatory": "Valittu asema: ",
      "rowsPerPage": "Rivejä sivulla: ",
      "all": "Kaikki",
      "to": ", Yhteensä: ",
      "links": "Linkit",
      "direction": "Suunta",
      "bypassSide": "Ohituspuoli",
      "scatteredMigration": "Hajahavainnot",
      "latestDays": "Viimeisimmät päivät",
      "obsPeriod": "Havaintojakso",
      "at": "kello",

      // form texts
      "date": "Päivämäärä",
      "year": "Vuosi",
      "observers": "Havainnoija(t)",
      "observations": "Havainnot",
      "migrantObservations": "Muuttohavainnot",
      "comment": "Havainnointi- ja pyydyskommentit",
      "commentAdded": "Kommentteja kirjattu",
      "noComment": "Ei kommentteja",
      "catchArea": "Pyyntialue",
      "catchMethod": "Pyyntitapa",
      "netLength": "Verkon pituus",
      "catchCount": "Lukumäärä",
      "copy": "Kopioi edellinen päivä",
      "chooseCopy": "Valitse edelliseltä päivältä kopioitavat tiedot.",
      "draftInfoText": "Valitse palautettava luonnos. \nLuonnokset ovat automaattisesti tallennettu paikallisesti selaimen välimuistiin. \nVanhat luonnokset siivotaan automaattisesti pois.",
      "overwrite": "Huom! Valitut tiedot ylikirjaavat mahdolliset kyseiseen kohtaan tälle päivälle tehdyt merkinnät.",
      "days": "Päivät",
      "observationStation": "Havainnointiasema",
      "formSent": "Lomake lähetetty!",
      "formNotSent": "Lomakkeen lähetys ei onnistunut. Yritä hetken kuluttua uudelleen ja jos virhe ei korjaannu, ota yhteyttä ylläpitoon.",
      "readMore": "Lue lisää",
      "location": "Sijainti",
      "observationperiod": "Havaintoperiodi",
      "observation": "Havainto",
      "type": "Tyyppi",
      "startTime": "Alkuaika",
      "endTime": "Loppuaika",
      "chooseTypeAndLocation": "(Valitse tyyppi ja sijainti)",
      "netopened": "Avattu",
      "netclosed": "Suljettu",
      "duration": "Kesto",
      "addObservations": "Lisää havaintoja",
      "species": "Laji",
      "count": "Lukumäärä",
      "totalCount": "Muutto Yht",
      "constantMigration": "Vakio",
      "otherMigration": "Muu muutto",
      "nightMigration": "Yömuutto",
      "localTotal": "Paikalliset Yht",
      "localCount": "Paikalliset",
      "localGau": "Paikalliset Gåu",
      "ObservationActivity": "Havainnointiaktiivisuus",
      "observationActivityAdded": "Havainnointiaktiivisuus kirjattu",
      "noObservationActivity": "Ei havainnointiaktiivisuusmerkintöjä",
      "catches": "Pyydykset",
      "catchesAdded": "Pyydystietoja kirjattu",
      "noCatches": "Ei pyydyksiä",
      "errorsInCatches": "Virheitä pyydyksissä!",
      "wasOpen": "Auki",
      "amount": "Lkm",
      "length": "Pituus (m)",
      "noCatchArea": "Valitse pyyntialue jatkaaksesi",
      "noCatchesDeclared": "Ei ilmoitettuja pyydyksiä.",
      "standardObs": "Vakiohavainnointi",
      "gåu": "Gåulla käynti",
      "standardRing": "Rengastusvakio",
      "owlStandard": "Pöllövakio",
      "mammals": "Nisäkkäät yms. laskettu",
      "attachments": "Liitteitä",
      "pcs": "kpl",
      "pcsUpper": "Kpl",
      "notes": "Lisätiedot",
      "filter": "Suodata",
      "drafts": "Luonnokset",
      "locationCount_one": "{{count}} sijainti",
      "locationCount_other": "{{count}} sijaintia",
      "observationPeriodCount_one": "{{count}} havaintojakso",
      "observationPeriodCount_other": "{{count}} havaintojaksoa",

      // buttons & confirmation
      "cancel": "Peruuta",
      "remove": "Poista",
      "confirm": "Vahvista",
      "confirmDeletion": "Vahvista poisto",
      "speciesCount_one": "{{count}} laji",
      "speciesCount_other": "{{count}} lajia",
      "edit": "Muokkaa",
      "editObservations": "Muokkaa havaintoja",
      "editShorthand": "Muokkaa pikakirjoitusta",
      "removingCannotBeCancelled": "Poistamista ei voi peruuttaa. Jatketaanko?",
      "observationPeriodNotDefined": "Havainnointijaksoa ei ole määritelty!",
      "noObservationsFound": "Havainnointitietoja ei löytynyt tälle päivälle.",
      "addRowByClicking": "Lisää pyydys painamalla '+'.",
      "addStandardCatchRowsByClicking": "Lisää vakiopyydykset painamalla '+'.",
      "rowRemoved": "Pyydysrivi poistetaan. Vahvista painamalla 'Poista'.",
      "modify": "Muokkaa",
      "save": "Tallenna",
      "saveMigrant": "Tallenna muuttohavainnot",
      "helpForSaveMigrantButton": "Tallenna syötetyt muuttohavainnot valitulla havaintotyypillä ja -sijainnilla. Syötäthän lisäksi havainnoitsijan tiedot sille osoitettuun kenttään ennen tallentamista. Myös muiden kenttien tiedot (kommentit, aktiivisuus, pyydykset) tallennetaan.",
      "loading": "Ladataan...",
      "toDayDetails": "Siirry koontinäkymään",
      "helpForToDayDetailsButton": "Siirry valitun päivän koontinäkymään. Syötäthän havainnoitsijan, jos kenttä on tyhjä, jotta painike aktivoituu.",
      "showOnlyBirdsWithObservations": "vain lajit, joista on havaintoja",
      "speciesTextFilter": "Lajihaku",
      "shownSpecies": "Näytettävät lajit",
      "observatoryDefaults": "aseman peruslajit",
      "otherSpecies": "muut kuin peruslajit",
      "allSpecies": "kaikki lajit",
      "addNewSpecies": "Lisää uusi laji",

      // notifications & errors
      "periodsTimesMustBeDifferent": "Aloitus- ja lopetusajan on oltava eri",
      "invalidDate": "Virheellinen päivämäärä",
      "maxDateError": "Päivämäärä on liian suuri",
      "minDateError": "Päivämäärä on liian pieni",
      "periodSaved": "Lomake tallennettu tietokantaan",
      "periodNotSaved": "Lomakkeen tallennuksessa ongelmia.",
      "lineError": "Virhe rivillä ",
      "oddNumberOfTimes": "Pariton määrä aikoja",
      "startTimeMissing": "Aloitusaika puuttuu",
      "unknownSpeciesError": "Tuntematon lajinnimi",
      "missingSpaceAfterSpecies": "Lajinimen jälkeen puuttuu välilyönti",
      "spaceBetweenNumbers": "Numeroiden välissä ei saa olla välilyöntiä",
      "sameAgeMultipleTimes": "Sama ikä on moneen kertaan",
      "hasAlreadyCommonDirection": "Ilmansuunta on annettu moneen kertaan",
      "directionNotAllowed": "Ilmansuunta ei ole sallittu",
      "multipleFlocksNotAllowed": "Syötä vain yksi havainto",
      "directionBeforeCounts": "Ilmansuunnan tulee olla lukumäärien jälkeen",
      "bypassSideBeforeCounts": "Ohituspuolen tulee olla lukumäärien jälkeen",
      "bypassSideBeforeDirection": "Ohituspuolen tulee olla ilmansuunnan jälkeen",
      "notesBeforeCounts": "Muistiinpanojen tulee olla lukumäärien jälkeen",
      "notesBeforeDirection": "Muistiinpanojen tulee olla ilmansuunnan jälkeen",
      "notesBeforeBypassSide": "Muistiinpanojen tulee olla ohituspuolen jälkeen",
      "ageNotAfterCount": "Iän tulee olla lukumäärän jälkeen",
      "multipleDirections": "Virheellinen ilmansuunta tai ilmansuunta on moneen kertaan",
      "multipleBypassSides": "Virhellinen ohitussuunta tai ohitussuunta on moneen kertaan",
      "multipleNotes": "Lisätiedot on moneen kertaan",
      "observationHasMultipleAges": "Yhdellä havainnolla on monta ikää",
      "extraCommas": "Ylimääräisiä pilkkuja",
      "extraSlashes": "Ylimääräisiä kauttaviivoja",
      "incorrectBrackets": "Virheelliset sulut",
      "emptyObservation": "Tyhjä havainto",
      "unknownTerm": "Tuntematon termi: {{term}}",
      "checkRow": "Tarkista rivi {{row}}: ",
      "checkShorthand": "Tarkista pikakirjoitus",
      "errorsInObservationActivity": "Virheitä havainnointiaktiivisuusmerkinnöissä!",
      "valueIsNegative": "Negatiivinen arvo!",
      "recheckLargeNumberOfAttachments": "Olet ilmoittamassa poikkeuksellisen ison määrän liitteitä. Tarkistathan, että syöttämäsi summa on oikein.",
      "valueMissing": "Arvo puuttuu!",
      "noNegativeValues": "Negatiiviset arvot eivät ole sallittuja!",
      "noEmptyValues": "Kenttä ei saa olla tyhjä",
      "changeDateWhenObservationsConfirm": "Päivän vaihtaminen hävittää tekemäsi merkinnät. Haluatko vaihtaa päivää?",
      "recheckNumberOfCatches": "Pyydysten '{{char}}' määrä on huomattavan suuri. Tarkistathan, että se on oikein ennen kuin tallennat.",
      "checkNetLength": "Verkon '{{char}}' pituus on yleensä 9-12 metriä. Tarkistathan ennen tallentamista, että syötit tarkoittamasi pituuden.",
      "closeBeforeOpen": "Pyydys '{{char}}' merkitty suljetuksi ennen avausaikaa.",
      "noZeroAmount": "Pyydyksen '{{char}}' lukumäärä ei voi olla 0.",
      "maxCatchValue": "Pyydyksen '{{char1}}' lukumäärä voi olla korkeintaan {{char2}}.",
      "expectingStandardCatch": "Rengastusvakio on merkitty tehdyksi. Lisää ainakin yksi vakioverkko.",
      "duplicateCatches": "Pyydys '{{char}}' on ilmoitettu useampaan kertaan. Tarkistathan pyydykset.",
      "periodsEndTimeMustBeAfterStartTime": "Havainnon lopetusajan on oltava aloitusajan jälkeen.",
      "periodsStartTimeMustBeAfterPreviousEndTime": "Havainnon aloitusaika ei voi olla ennen edellisen havainnon lopetusaikaa.",
      "pauseAlreadyActive": "Jakso on jo kirjattu tauoksi.",
      "noPauseDuringEmptyPeriod": "Havainnointijakso on jo merkitty tyhjäksi, eikä voi olla tauolla.",
      "noObservationsDuringPause": "Tauolla ei voi kirjata havaintoja.",
      "alreadyEmpty": "Jakso on jo merkitty tyhjäksi.",
      "noEmptyDuringPause": "Jaksoa ei voi kirjata tyhjäksi tauolla.",
      "noObservationsDuringEmptyPeriod": "Tyhjällä jaksolla ei voi olla havaintoja.",
      "noObservations": "Ei ole kirjattu yhtään havaintoa.",
      "periodContainsNothing": "Jakso, jolla ei ole havaintoja, on kirjattava joko tyhjäksi (-) tai tauoksi (tauko).",
      "mustEndWithTime": "Havaintojen on päätyttävä kellonaikaan.",

      "noRequiredRoles": "Jos tarvitset pääsyn sovellukseen, voit pyytää sitä sähköpostilla.",
      "confirmExit": "Haluatko varmasti poistua tallentamatta muutoksia?",
      "dayObservationsFetchFailed": "Havaintojen hakeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
      "observationsFetchFailed": "Havaintojen hakeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
      "shorthandFetchFailed": "Pikakirjoituksen hakeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
      "observationPeriodCountsFetchFailed": "Havaintojaksojen hakeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
      "copyDayFailed": "Päivän tietojen kopioiminen epäonnistui. Yritä hetken kuluttua uudelleen.",
      "confirmRemoveDay": "Haluatko varmasti poistaa kaikki tiedot päivältä {{day}}? Poistamista ei voi peruuttaa.",
      "removeFailed": "Päivän poistaminen ei onnistunut. Yritä hetken kuluttua uudelleen.",
      "requiredField": "Pakollinen kenttä",
      "unexpectedError": "Odottamaton virhe tapahtui. Yritä hetken kuluttua uudelleen ja jos virhe ei korjaannu, ota yhteyttä ylläpitoon.",
      "latestDaysError": "Viimeisimpien päivien haku ei onnistunut. Yritä hetken kuluttua uudelleen.",
      "errorMessage": "Virhe",
      "logoutFailed": "Uloskirjautuminen epäonnistui. Yritä hetken kuluttua uudelleen."
    },
  },
};
export { resources };
